export type Nullable<T> = T | null;

export const voidFunction = () => { };

export type PatternFormatValues = {
  formattedValue: string;
  value: string;
  floatValue: number | undefined;
}

export enum AsyncOpStatus {
  IDLE = 'idle',
  BUSY = 'busy',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum AsyncOpStatusWithTerminate {
  IDLE = 'idle',
  BUSY = 'busy',
  SUCCESS = 'success',
  ERROR = 'error',
  TERMINATE = 'terminate'
}

export enum InspectionSortingVariants {
  DATE_CREATE_DESC = 'date_create_desc',
  DATE_COMPLETION_DESC = 'date_completion_desc',
  INSPECTIONS_ID_DESC = 'inspections_id_desc',
}